import { default as cardFormatUtils } from './utils.js';

const validation = {
    validateCardNumber: function (num) {
        num = (num + '').replace(/\s+|-/g, '');
        if (!/^\d+$/.test(num)) { return false; }

        let card = cardFormatUtils.cardFromNumber(num);
        if (!card) { return false; }

        return Array.from(card.length).includes(num.length) &&
            ((card.luhn === false) || cardFormatUtils.luhnCheck(num));
    },

    cardType: function (num) {
        if (!num) { return null; }
        return cardFormatUtils.__guard__(cardFormatUtils.cardFromNumber(num), x => x.type) || null;
    },

    formatCardNumber: function (num) {

        num = num.toString().replace(/\D/g, '');
        let card = cardFormatUtils.cardFromNumber(num);
        if (!card) { return num; }

        let upperLength = card.length[card.length.length - 1];
        num = num.slice(0, upperLength);

        if (card.format.global) {
            return cardFormatUtils.__guard__(num.match(card.format), x => x.join(' '));
        } else {
            let groups = card.format.exec(num);
            if (groups == null) { return; }
            groups.shift();
            // @TODO: Change to native filter()
            //groups = grep(groups, n => n); // Filter empty groups
            return groups.join(' ');
        }
    },
};

export default validation;